import React, {Fragment, useState, useEffect} from "react";
import Breadcrumb from "../../common/breadcrumb/breadcrumb";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";
import utentiUtils from "../../crud/utenti/utentiutils";
import {gruppi} from '../../../api/groups'
import {utenti} from '../../../api/users'
import {ruoli} from '../../../api/roles'
import {ToastContainer, toast} from "react-toastify";
import {useQuery} from '../../../hook/useQuery'


const Profilo = (props) => {

    const query = useQuery();

    const userId = query.get('id');
    const [groupid, setGroupId] = useState('');

    const [id, setId] = useState(userId ? userId : null);
    const [name, setName] = useState('');
    const [roleid, setRoleId] = useState('');
    const [rolename, setRoleName] = useState('');
    const [surname, setSurname] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [listaruoli, setListaRuoli] = useState([]);
    const [listagruppi, setListaGruppi] = useState([]);
    const [isloading, setIsLoading] = useState(false);
    const [enabled, setEnabled] = useState(true);

    useEffect(() => {
      load();
    }, []);

    useEffect(() => {

    }, [userId]);

    const load = async () => {
      try {
        setId(query.get('id'));
        const listGroup = await gruppi.methods.loadGruppi();
        setListaGruppi(listGroup);
        const listRoles = await ruoli.methods.loadRuoli();
        setListaRuoli(listRoles);
        const listautentiraw = await utenti.methods.loadUtenti(query.get('id'));
        console.log(listautentiraw);
        if (listautentiraw) {
          loadFormEdit(listautentiraw)
        }
      } catch (e) {
        toast.error('Qualcosa è andato storto');
      }
    }


    const clearForm = () => {
      setId(null);
      setName('')
      setRoleId('')
      setGroupId('')
      setRoleName('')
      setSurname('')
      setUsername('')
      setPassword('')
      document.getElementById('roleselect').value='';
      document.getElementById('groupselect').value='';
    }

    const loadFormEdit = (row) => {
      setId(row.id);
      setName(row.name)
      setRoleId(row.role.id)
      setGroupId(row.groups[0].id)
      setSurname(row.surname)
      setUsername(row.username)
      setPassword(row.password)
      document.getElementById('roleselect').value=row.role.id;
      document.getElementById('groupselect').value=row.groups[0].id;
    }

    const submit = async () => {
      setIsLoading(true)
      setId(query.get('id'));
      const inputobject =
        {
          "id" : id,
          "enabled": true,
          "groups": [
            {
              "id": groupid,
              "name": 'admin'//groupname
            }
          ],
          "name": name,
          "role": {
            "id": roleid,
            "role": 'admin'//rolename
          },
          "surname": surname,
          "username": username,
          "password":password
        }
      // if(id) inputobject.id=(id);
      const validateresult = utentiUtils.methods.validateUtente(inputobject);
      if (validateresult.length > 0) {
        console.log(2);
        //TODO gestire validate field su campo input
        validateresult.forEach((e) => {
            console.log(e);
            setTimeout(() => {
              toast.error(
                e.field + ':' + e.error
              );
            }, 300);


          }
        );

        setIsLoading(false)

        return;
      }

      const result = await utentiUtils.methods.saveUtente(inputobject, id);

      if (result) {
        setTimeout(() => {
          toast.success(
            "Utente salvata..."
          );

        }, 300);
      } else {
        setTimeout(() => {
          toast.error(
            "Qualcosa è andato storto..."
          );
        }, 300);

      }
      clearForm();
      load(true);
      setIsLoading(false)
    }


    return (
      <Fragment>
        <Breadcrumb parent="Profilo" title="Gestione" subtitle="Profilo"/>
        <Container fluid={true}>
          <Row>
            <Col xs="12">
              <Card className="card-absolute">
                <CardHeader className="bg-primary">
                  <h5>Dati Utente {username}</h5>
                </CardHeader>
                <CardBody className="add-post">
                  <Form id="savesession" className="row needs-validation">
                    <Col sm="12">
                      <Row>
                        <Col xs="12" sm="6" md="6" xl="6" lg="6">
                          <FormGroup>
                            <Label for="validationCustom01">Nome:</Label>
                            <Input
                              className="form-control"
                              id="input_nome_utente"
                              type="text"
                              placeholder=""
                              required={true}
                              value={name}
                              onChange={(e) => {
                                setName(e.target.value)
                              }}
                            />
                            <div className="valid-feedback">Ok!</div>
                          </FormGroup>

                        </Col>
                        <Col xs="12" sm="6" md="6">

                          <FormGroup>
                            <Label for="validationCustom01">Cognome:</Label>
                            <Input
                              className="form-control"
                              id="input_cognome_utente"
                              type="text"
                              placeholder=""
                              required={true}
                              value={surname}
                              onChange={(e) => {
                                setSurname(e.target.value)
                              }}
                            />
                            <div className="valid-feedback">Ok!</div>
                          </FormGroup>

                        </Col>


                      </Row>
                      <Row>
                        <Col xs="12" sm="6" md="6" xl="6" lg="6">
                          <FormGroup>
                            <Label for="validationCustom01">Username:</Label>
                            <Input
                              className="form-control"
                              id="input_nome_utente"
                              type="text"
                              placeholder=""
                              required={true}
                              value={username}
                              readOnly
                              onChange={(e) => {
                                setUsername(e.target.value)
                              }}
                            />
                            <div className="valid-feedback">Ok!</div>
                          </FormGroup>

                        </Col>
                        <Col xs="12" sm="6" md="6">

                          <FormGroup>
                            <Label for="validationCustom01">Password:</Label>
                            <Input
                              className="form-control"
                              id="input_cognome_utente"
                              type="text"
                              placeholder=""
                              required={true}
                              value={password}
                              onChange={(e) => {
                                setPassword(e.target.value)
                              }}
                            />
                            <div className="valid-feedback">Ok!</div>
                          </FormGroup>

                        </Col>


                      </Row>
                      <Row>
                        <Col xs="12" sm="6" md="6" xl="6" lg="6">
                          <FormGroup>
                            <Label for="validationCustom01">Gruppo:</Label>
                            <select disabled id="groupselect" className="form-control btn-pill" onChange={(e) => {
                              setGroupId(e.target.value)
                            }} size="1">
                              <option value=''>Seleziona</option>
                              {
                                Array.isArray(listagruppi) ? listagruppi.map((data, i) => {
                                  return (
                                    <option value={data.id}>{data.name}</option>
                                  );
                                }) : <option value={1}>{'admin'}</option>
                              }


                            </select>


                          </FormGroup>

                        </Col>
                        <Col xs="12" sm="6" md="6" xl="6" lg="6">
                          <FormGroup>
                            <Label for="validationCustom01">Ruolo:</Label>
                            <select disabled id="roleselect" className="form-control btn-pill" onChange={(e) => {
                              setRoleId(e.target.value)
                            }} size="1">
                              <option value=''>Seleziona</option>
                              {
                                listaruoli.map((data, i) => {
                                  return (
                                    <option value={data.id}>{data.role}</option>
                                  );
                                })
                              }


                            </select>

                          </FormGroup>

                        </Col>

                      </Row>
                      <Row>
                        <Col xs="12" sm="9">

                        </Col>
                        <Col xs="12" sm="3">
                          <FormGroup>
                            <div className="checkbox checkbox-success">
                              <Input
                                id="checkbox-primary"
                                type="checkbox"
                                defaultChecked
                                onChange={(e) => {
                                  setEnabled(e.target.value)
                                }}
                              />
                              <Label for="checkbox-primary">Abilitato</Label>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Form>
                  <Row>
                    &nbsp;
                  </Row>
                  <div className="btn-showcase" style={{textAlign: 'right'}}>
                    <Button disabled={isloading} id="buttonsubmit" color="primary btn-pill" type="button"
                            onClick={submit}>
                      {id? 'Modifica' : 'Aggiungi'}
                    </Button>
                    <Button color="danger btn-pill" type="reset" onClick={clearForm}>
                      Annulla
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Col>

          </Row>

          <ToastContainer/>
        </Container>
      </Fragment>
    );
  }
;

export default Profilo;
